import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgToestemming = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#ECF9EC"
      fillRule="evenodd"
      d="M10 34h20V12h-6V6H10v28"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M6.75 32.33c2.7-1.78 5.34-3.62 8-5.49 1.7-1.22 4.8-3 3.41-5.53C16.88 19 13.8 19 11.91 20.5a3.43 3.43 0 0 0-1.39 2.73 3.94 3.94 0 0 0 1.66 2.95q.858.661 1.82 1.16a9 9 0 0 1 1.75 1c.58.49.44 1 0 1.54q-.992.964-2.1 1.79c-.51.4.21 1.1.7.7.92-.73 2.22-1.5 2.7-2.63a2 2 0 0 0-.88-2.36c-1.56-1.1-4.75-1.81-4.65-4.26.08-2.22 3.5-3.43 5.11-2.07a1.8 1.8 0 0 1 .51 2.5A11.3 11.3 0 0 1 14.21 26c-2.63 1.88-5.27 3.72-8 5.5-.54.35 0 1.22.5.86z"
    />
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="m24 6 3 3 3 3h-6z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="m30.24 17.88 1.88 1.88-11.3 11.3L18 32l.94-2.82zm3.76 0L32.12 16l-1.24 1.23 1.88 1.89z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M28.126 19.091a.7.7 0 0 0-.512.202l-4.07 4.061-.707-.708 4.07-4.06a1.69 1.69 0 0 1 1.922-.33c.204.096.386.233.536.402l.989.988-.707.708-1.013-1.013-.011-.013a.69.69 0 0 0-.497-.237"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgToestemming);

export default ForwardRef;
